import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import logo from "../../assets/svg/logo.svg";
import { isAuthenticated } from "../../router/PrivateRoute";
import { clearAccessToken } from "../../common";

const AuthWrapper = () => {
  const location = useLocation();

  const renderAuthLayout = () => (
    <div className="md:flex md:h-screen w-full items-center justify-center overflow-hidden">
      <div className="flex flex-col md:flex-row w-full h-full">
        {/* Left side - Image */}
        <div className="md:w-1/2 h-full hidden md:block">
          <img
            src={logo}
            alt="Login illustration"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right side - Auth Components */}
        <div className="w-full md:w-1/2 h-full overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );

  if (!isAuthenticated()) {
    clearAccessToken();
    return renderAuthLayout();
  }

  try {
    let data = localStorage.getItem("userData");
    if (!data) {
      clearAccessToken();
      localStorage.clear();
      return <Navigate replace to="/" />;
    }

    const userData = JSON.parse(data);

    // If user exists but account is not yet active, keep them on approval flow
    // but still allow access to Details page for completing profile and login page.
    if (userData?.isActive === false || userData?.isActive === 0) {
      const allowedInactivePaths = ["/approval", "/details", "/login", "/account", "/"];

      if (!allowedInactivePaths.includes(location.pathname)) {
        return <Navigate replace to="/approval" />;
      }

      return renderAuthLayout();
    }

    if (userData?.role === "user") {
      return <Navigate replace to="/student" />;
    } else if (userData?.role === "admin" || userData?.role === "subadmin") {
      return <Navigate replace to="/admin" />;
    }

    return <Navigate replace to="/admin" />;
  } catch (error) {
    console.error("Error parsing user data in AuthWrapper:", error);
    clearAccessToken();
    localStorage.clear();
    return <Navigate replace to="/" />;
  }
};

export default AuthWrapper;
